import * as iconDrKeyword from './dr-keyword'
import * as iconImpactivo from './impactivo'
import * as iconGlobals from './globals'
import * as iconMindfit from './mindfit'

export const icons = {
  ...iconGlobals,
  ...iconMindfit,
  ...iconDrKeyword,
  ...iconImpactivo
}
